import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'change-status-modal',
  templateUrl: './change-status-modal.component.html',
})
export class ChangeStatusModalComponent implements OnInit {
  @Input() workOrder: any;

  public form: FormGroup;

  public approvalStatuses = ['PENDING', 'APPROVED', 'REJECTED'];

  constructor(
    private activeModal: NgbActiveModal,
    private workOrderService: SiteWorkOrdersService,
    private formBuilder: FormBuilder,
  ) { }


  ngOnInit() {
    const commentRequiredValidator = (formGroup: FormGroup) => {
      if (formGroup.value.approvalStatus === 'REJECTED') {
        if (Validators.required(formGroup.get('comment'))) {
          return { commentRequiredForRejected: true }
        };
      }
      return null;
    }

    this.form = this.formBuilder.group({
      approvalStatus: new FormControl(this.workOrder.approvalStatus, [Validators.required]),
      released: new FormControl(this.workOrder.released),
      comment: new FormControl('', [Validators.maxLength(255)]),
    }, {
      validator: [commentRequiredValidator]
    });

    this.form.get('approvalStatus').valueChanges.subscribe(value => {
      if (value !== 'APPROVED') {
        this.form.patchValue({
          released: false,
        });
      }
    });
  }

  get approvalStatus() {
    return this.form.get('approvalStatus').value
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    const values = this.form.value;

    const body = {
      released: values.released,
      approvalStatus: values.approvalStatus,

      // required for the PUT Request:
      id: this.workOrder.id,
      description: this.workOrder.description,
      minimumPartySize: this.workOrder.minimumPartySize,
      checkOnSiteFormId: this.workOrder.checkOnSiteFormId,
      checkOffSiteFormId: this.workOrder.checkOffSiteFormId,
      scheduledStartTime: this.workOrder.scheduledStartTime,
      scheduledEndTime: this.workOrder.scheduledEndTime,
      exemptFromAssetScheduling: this.workOrder.exemptFromAssetScheduling,
    };

    const commentBody = {
      workOrderId: this.workOrder.id,
      comment: values.comment,
    };

    this.workOrderService.updateWorkOrder(body).subscribe(() => {

      const callback = () => {
        Swal.fire('Updated!', 'Work Order has been updated.', 'success');
        this.activeModal.close('refresh');
      }

      if (body.approvalStatus === 'REJECTED') {
        this.workOrderService.addWorkOrderComment(commentBody).subscribe(() => {
          callback();
        });
      } else {
        callback();
      }
    });
  }
}
